<template>
  <!--begin::Wrapper container-->
  <div class="app-container container-xxl">
    <!--begin::Main-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
      <!--begin::Content wrapper-->
      <div class="d-flex flex-column flex-column-fluid">
        <!--begin::Content-->
        <div id="kt_app_content" class="app-content">
          <!--begin::About -->

          <div v-if="settings">                  
            <div class="divide-y tube-card md:m-0 -mx-5" v-if="experts">
              <div class="md:flex" style="position: relative;">
                  <div class="flex-1">
                    <h3>{{ $t('request_now') }}  </h3>
                  </div>
              </div>

              <div class="md:flex md:space-x-6 py-5" style="position: relative;">
                <h4>{{ $t('location_description') }}</h4>
                <div class="flex-1 md:pt-0 pt-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('select_date') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <VueDatePicker v-model="booking.date" format="dd-MM-yyyy" :enable-time-picker="false" :auto-apply="true" v-if="booking.date_unknown == 0"></VueDatePicker>
                        <input required name="date_unknown" type="checkbox" style="margin-left: 10px; width: 15px; height: 15px; float: left; display: inline-block; border: 3px solid #ccc; margin-top: 10px;" v-model="booking.date_unknown">
                        <span style="top: 7px;position: relative;left: 10px;">{{ $t('date_unknown') }}</span>
                      </div>
                    </div>
                    <div class="col-lg-4" v-if="booking.date_unknown == 0">
                      <h5 class="mb-2">{{ $t('date_start') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.date_start" name="date_start" :placeholder="$t('date_start')" type="time" class="form-control form-control-solid">
                      </div>
                    </div>
                    <div class="col-lg-4" v-if="booking.date_unknown == 0">
                      <h5 class="mb-2">{{ $t('date_end') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.date_end" name="date_end" :placeholder="$t('date_end')" type="time" class="form-control form-control-solid">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-10">
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('select_speaker') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <VueMultiselect v-model="booking.id" :options="experts" label="title" track-by="id" :searchable="true" :multiple="true" placeholder="Select speaker" style="width: 100%;"></VueMultiselect>
                        <span style="display: none;">
                          <input required name="unknown_speaker" type="checkbox" style="margin-left: 10px; width: 15px; height: 15px; float: left; display: inline-block; border: 3px solid #ccc;" v-model="booking.unknown_speaker">
                          <span style="top: -3px;position: relative;left: 10px;">{{ $t('speaker_unknown') }}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-10">
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('location') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.location" name="location" :placeholder="$t('location')" type="text" class="form-control form-control-solid">
                      </div>
                    </div>

                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('keynote_subject') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <VueMultiselect v-model="booking.keynote_subject" :options="expert.keynote_topics" label="keynote" track-by="keynote" :searchable="false" :multiple="false" :placeholder="$t('keynote_subject')" style="width: 100%;"></VueMultiselect>
                      </div>
                    </div>

                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('amount_of_visitors') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.amount_of_visitors" name="amount_of_visitors" :placeholder="$t('amount_of_visitors')" type="number" class="form-control form-control-solid">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-10">
                    <div class="col-lg-12">
                      <h5 class="mb-2">{{ $t('description') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <textarea required v-model="booking.remark" name="remark" :placeholder="$t('description_event')" class="form-control form-control-solid" style="height: 150px;"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="md:flex md:space-x-6 py-5" style="position: relative;">
                <h4>{{ $t('invoice_details_label') }}</h4>
                <div class="flex-1 md:pt-0 pt-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('email') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.email" name="email" :placeholder="$t('email')" type="email" class="form-control form-control-solid">
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('mobile') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.mobile" name="mobile" :placeholder="$t('mobile')" type="phone" class="form-control form-control-solid">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-10">
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('name') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.invoice_name" name="invoice_name" :placeholder="$t('name')" type="text" class="form-control form-control-solid">
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('company') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.invoice_company" name="invoice_company" type="text" :placeholder="$t('company')" class="form-control form-control-solid">
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('vat') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.invoice_vat" name="invoice_vat" type="text" :placeholder="$t('vat')" class="form-control form-control-solid">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-10">
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('address') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.invoice_address" name="invoice_address" type="text" :placeholder="$t('address')" class="form-control form-control-solid">
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('postal') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.invoice_postal" name="invoice_postal" type="number" :placeholder="$t('postal')" class="form-control form-control-solid">
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <h5 class="mb-2">{{ $t('city') }}</h5>
                      <div class="fs-5 text-muted fw-semibold">
                        <input required v-model="booking.invoice_city" name="invoice_city" type="text" :placeholder="$t('city')" class="form-control form-control-solid">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-10">
                    <span v-if="settings && settings.privacy_url_nl" style="display: block; height: 35px;">
                        <input required name="privacy" type="checkbox" style="width: 25px; height: 25px; float: left; display: inline-block; border: 3px solid #ccc;" v-model="booking.privacy"> <span style="width: 220px;top: 0px;position: relative;left: 10px;"><a :href="`${settings.privacy_url_nl}`" target="_blank">I agree with the privacy policy</a></span>
                    </span>
                    <span style="display: block; height: 35px;">
                        <input v-model="booking.subscribe_newsletter" type="checkbox" style="width: 25px; height: 25px; float: left; display: inline-block; border: 3px solid #ccc;"> <span style="width: 220px;top: 0px;position: relative;left: 10px;">I want to signup for the newsletter</span>
                    </span>
                  </div>

                  <button v-if="booking.privacy || settings.privacy_url_nl == ''" @click="sentBooking()" class="btn btn-primary mt-10">{{ $t('confirm_estimate') }}</button>
                </div>
              </div>
            </div>
          </div>


          <!--end::About -->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Content wrapper-->
    </div>
    <!--end:::Main-->
  </div>
  <!--end::Wrapper container-->
</template>

<script>
  import VueMultiselect from 'vue-multiselect';
  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css'
  import axios from 'axios';

  export default {
    components: { VueMultiselect, VueDatePicker },
    data() {
      return {
        expert: { 
          keynote_topics: []
        },
        settings: null,
        booking: {
            subscribe_newsletter: true,
            language: this.$i18n.locale,
            booking_flow: 1,
            id: null,
            unknown_speaker: 0,
            category: 0,
            type: 0,
            date: new Date().toISOString().substr(0, 10),
            date_unknown: 0,
            date_start: '',
            date_end: '',
            email: '',
            privacy: false,
            invoice_company: '',
            invoice_name: '',
            invoice_address: '',
            invoice_postal: '',
            invoice_city: '',
            invoice_email: '',
            voucher: '',
            location: '',
            keynote_subject: '',
            amount_of_visitors: '',
            remark: '',
            notfound: false      
        },
        experts: []
      };
    },
    methods: {
      sentBooking() {
        let valid = true;

        if(this.booking.email == '') {
            valid = false;
            document.querySelector('input[name="email"]').style.border = '1px solid red';
        } else {
            document.querySelector('input[name="email"]').style.border = '1px solid #cccccc';
        }

        if(this.booking.invoice_company == '') {
            valid = false;
            document.querySelector('input[name="invoice_company"]').style.border = '1px solid red';
        } else {
            document.querySelector('input[name="invoice_company"]').style.border = '1px solid #cccccc';
        }

        if(this.booking.invoice_name == '') {
            valid = false;
            document.querySelector('input[name="invoice_name"]').style.border = '1px solid red';
        } else {
            document.querySelector('input[name="invoice_name"]').style.border = '1px solid #cccccc';
        }

        if(this.booking.invoice_address == '') {
            valid = false;
            document.querySelector('input[name="invoice_address"]').style.border = '1px solid red';
        } else {
            document.querySelector('input[name="invoice_address"]').style.border = '1px solid #cccccc';
        }

        if(this.booking.invoice_postal == '') {
            valid = false;
            document.querySelector('input[name="invoice_postal"]').style.border = '1px solid red';
        } else {
            document.querySelector('input[name="invoice_postal"]').style.border = '1px solid #cccccc';
        }

        if(this.booking.invoice_city == '') {
            valid = false;
            document.querySelector('input[name="invoice_city"]').style.border = '1px solid red';
        } else {
            document.querySelector('input[name="invoice_city"]').style.border = '1px solid #cccccc';
        }
        var token = localStorage.getItem('xperttoken');

        if(valid) {
            if(!token) {
            token = this.$token;
            }
            
            // Set the authorization header with the bearer token
            const instance = axios.create({
                baseURL: this.$baseURL,
                headers: {
                Authorization: `Bearer ${token}`,
                }
            });
            
            instance.post('/expert/payment', this.booking)
            .then(response => {
                window.top.location.href = response.data.mollie_url;
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                // Handle the error
            });
        }
      }
    },
    mounted() {
      const token = localStorage.getItem('xperttoken');
      var customerselected = localStorage.getItem('xpertcustomerselected');

      // Set the authorization header with the bearer token
      const instance = axios.create({
          baseURL: this.$baseURL,
          headers: {
          Authorization: `Bearer ${token}`,
          'Customer': customerselected,
          }
      });

      instance.get('/assets')
        .then(response => {
          console.log(response);
          this.experts = response.data.assets;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

      instance.get('/admin/settings')
        .then(response => {
            console.log(response);

            this.settings = response.data.settings;

            this.booking.booking_flow = this.settings.booking_flow.id;
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            // Handle the error
        });

      this.expert.keynote_topics.push({ 'keynote': 'Speaker' });
      this.expert.keynote_topics.push({ 'keynote': 'Moderator' });
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>